module.exports = __webpack_public_path__ + "img/logo-polinema.1e409f07.png";